if (!customElements.get('dbtfy-product-tab')) {
  customElements.define(
    'dbtfy-product-tab',
    class DbtfyProductTab extends HTMLElement {
      constructor() {
        super();

        this.productTab = this.querySelectorAll('.dbtfy-product-tab-block');

        this.displayType = this.dataset.displayType;
        this.block = this.dataset.block;

        if (this.block == 'false') {
          this.content = document.querySelector('product-info .dbtfy-product-tabs');
        } else {
          document.querySelector('.dbtfy-product-tabs.shown-as-separate').classList.remove('hidden');
          this.content = document.querySelector('.dbtfy-product-tabs.shown-as-separate .d-grid');

          if (this.displayType == 'horizontal') {
            document.querySelectorAll('.dbtfy-product-tab').forEach((element) => {
              element.classList.add('dbtfy-product-tabs-horizontal');
            });
          }
        }

        if (this.displayType == 'horizontal') {
          this.horizontalselector = document.querySelectorAll('dbtfy-product-tab-horizontal');
          this.horizontalselector.forEach((element) => {
            element.setAttribute('data-display-type', this.displayType);
          });
        } else {
          this.verticalSelector = document.querySelectorAll('.dbtfy-product-tab-block');
          this.verticalSelector.forEach((element) => {
            element.classList.add('grid--12-col');
          });
        }

        this.testMode = Shopify.designMode;
      }

      disconnectedCallback() {
        if (this.testMode) {
          this.selectEvent();
        }
      }

      connectedCallback() {
        if (this.testMode) {
          this.selectEvent = subscribe(PUB_SUB_EVENTS.shopifyEventBlockSelect, (e) => {
            if (e.detail.blockId === 'widget-product-tabs') {
              this.init();
            }
          });
          this.init();
        } else {
          this.init();
        }
      }

      init() {
        if (this.content) {
          this.content.innerHTML = '';
          this.content.classList.remove('hidden');

          const product_id = this.content.dataset.product;

          if (this.productTab) {
            this.productTab.forEach((productTab) => {
              if (!product_id || !productTab.dataset.product || productTab.dataset.product == product_id) {
                this.content.append(productTab);
              }
            });
          }
        }

        this.querySelectorAll('[id^="Details-"] summary.closeall').forEach((summary) => {
          summary.addEventListener('click', (event) => {
            const productAccordion = summary.parentNode.closest('.product__accordion');

            let prevSiblings = [];
            let prevSibling = productAccordion.previousElementSibling;
            while (prevSibling) {
              prevSiblings.push(prevSibling);
              prevSibling = prevSibling.previousElementSibling;
            }

            let nextSiblings = [];
            let nextSibling = productAccordion.nextElementSibling;
            while (nextSibling) {
              nextSiblings.push(nextSibling);
              nextSibling = nextSibling.nextElementSibling;
            }

            prevSiblings.forEach((sibling) => {
              sibling.querySelector('summary').setAttribute('aria-expanded', false);
              sibling.querySelector('details').removeAttribute('open');
            });

            nextSiblings.forEach((sibling) => {
              sibling.querySelector('summary').setAttribute('aria-expanded', false);
              sibling.querySelector('details').removeAttribute('open');
            });
          });
        });
      }
    }
  );
}

if (!customElements.get('dbtfy-product-tab-horizontal')) {
  customElements.define(
    'dbtfy-product-tab-horizontal',
    class DbtfyProductTabHorizontal extends HTMLElement {
      constructor() {
        super();
        if (this.dataset.displayType == 'horizontal') {
          this.init();
        }
      }

      init() {
        this.querySelectorAll('[id^="Details-"] summary.closeall').forEach((summary) => {
          summary.addEventListener('click', (event) => {
            const productAccordion = summary.parentNode.closest('.product__accordion');

            let prevSiblings = [];
            let prevSibling = productAccordion.previousElementSibling;
            while (prevSibling) {
              prevSiblings.push(prevSibling);
              prevSibling = prevSibling.previousElementSibling;
            }

            let nextSiblings = [];
            let nextSibling = productAccordion.nextElementSibling;
            while (nextSibling) {
              nextSiblings.push(nextSibling);
              nextSibling = nextSibling.nextElementSibling;
            }

            prevSiblings.forEach((sibling) => {
              sibling.querySelector('summary').setAttribute('aria-expanded', false);
              sibling.querySelector('details').removeAttribute('open');
            });

            nextSiblings.forEach((sibling) => {
              sibling.querySelector('summary').setAttribute('aria-expanded', false);
              sibling.querySelector('details').removeAttribute('open');
            });
          });
        });
      }
    }
  );
}
